import { UseFormReturn } from "react-hook-form";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { CustomerFormData } from "./types";

interface ConsentSectionProps {
  form: UseFormReturn<CustomerFormData>;
}

export const ConsentSection = ({ form }: ConsentSectionProps) => {
  return (
    <>
      <FormField
        control={form.control}
        name="marketingConsent"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel className="text-white">
                Keep me updated with promotional offers and event updates
              </FormLabel>
            </div>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="termsAccepted"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel className="text-white">
                I accept the <a
                  href="/pdf/tos.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-purple-300"
                >terms of service</a> and <a
                  href="/pdf/pp.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-purple-300"
                >privacy policy</a> <span className="text-red-500">*</span>
              </FormLabel>
              <FormMessage />
            </div>
          </FormItem>
        )}
      />
    </>
  );
};